import { createStructuredSelector } from "reselect";
import { selectAccountID } from '../../../../selectors/globalSelectors';


export const getinvestmentOptionDetail = data => {
  return data.investmentOptionDetail;
};

/**************************** HistoricNav ***********************/

export const getinvestmentOptionTableData = data => {
  const tableDetails = getinvestmentOptionDetail(data);
  return tableDetails.tableData;
};

/**************************** investmentOption ***********************/

export const getinvestmentOptionInvestmentUST = data => {
  const investment = getinvestmentOptionDetail(data);
  return investment.investmentUST;
};

export const getinvestmentOptionMyInvestmentUST = data => {
  const myInvestment = getinvestmentOptionDetail(data);
  return myInvestment.myInvestmentUST;
};

export const getinvestmentOptionDrupalInvestment = data => {
  const drupalInvestment = getinvestmentOptionDetail(data);
  return drupalInvestment.investmentDrupal;
};
export const getinvestmentOptionDrupalUnderlying = data => {
  const drupalUnderlying = getinvestmentOptionDetail(data);
  return drupalUnderlying.underlyingDrupal;
};

export const getinvestmentOptionQuaterlyReport = data => {
  const quaterlyReport = getinvestmentOptionDetail(data);
  return quaterlyReport.quaterlyReport;
};

/***************************** Selectors HistoricNav ******************/
export const selectTableData = state => {
  const tableData = getinvestmentOptionTableData(state);
  return tableData.data;
};

export const selectIsLoadingUnderlyingTable = state => {
  const loadingData = getinvestmentOptionTableData(state);
  return loadingData.isLoading;
};

export const selectAccountType = state => {
  const accountType = getinvestmentOptionDetail(state);
  return accountType.investmentUST.data[0].accountType;
};

/***************************** Selectors investmentOption ******************/
export const selectInvestmentUST = state => {
  const investmentUST = getinvestmentOptionInvestmentUST(state);
  return investmentUST.data;
};

export const selectIsLoadingUST = state => {
  const investmentUSTLoading = getinvestmentOptionInvestmentUST(state);
  return investmentUSTLoading.isLoading;
};

export const selectMyInvestmentUST = state => {
  const myInvestmentUST = getinvestmentOptionMyInvestmentUST(state);
  return myInvestmentUST.data;
};

export const selectIsLoadingMyUST = state => {
  const myInvestmentUSTLoading = getinvestmentOptionMyInvestmentUST(state);
  return myInvestmentUSTLoading.isLoading;
};

export const selectInvestmentDrupal = state => {
  const investmentDrupalData = getinvestmentOptionDrupalInvestment(state);
  return investmentDrupalData.data;
};

export const selectInvestmentDrupalLoading = state => {
  const investmentDrupalLoading = getinvestmentOptionDrupalInvestment(state);
  return investmentDrupalLoading.isLoading;
};

export const selectUnderlyingDrupal = state => {
  const underlyingDrupalData = getinvestmentOptionDrupalUnderlying(state);
  return underlyingDrupalData.data;
};

export const selectUnderlyingDrupalLoading = state => {
  const underlyingDrupalLoading = getinvestmentOptionDrupalUnderlying(state);
  return underlyingDrupalLoading.isLoading;
};

export const selectQuaterlyReport = state => {
  const quaterlyReportData = getinvestmentOptionQuaterlyReport(state); 
  return  quaterlyReportData.data
};

export const selectQuaterlyReportLoading = state => {
  const quaterlyReportLoading = getinvestmentOptionQuaterlyReport(state);
  return quaterlyReportLoading.isLoading;
};

export const selectProcessedData = state => {
  const processedData = getinvestmentOptionDetail(state);
  return processedData.processed.data;
};

/***************************** DerivedStates - historicNav ******************/

export const investmentHistoricNavDerivedStates = createStructuredSelector({
  tableData: selectTableData,
  isLoadingUnderlyingTable: selectIsLoadingUnderlyingTable,
  accountType: selectAccountType,
  accountID: selectAccountID
});
/***************************** DerivedStates - investmentOption ******************/

export const investmentOptionDerivedStates = createStructuredSelector({
  investmentUST: selectInvestmentUST,
  myInvestmentUST: selectMyInvestmentUST,
  investmentDrupal: selectInvestmentDrupal,
  underlyingDrupal: selectUnderlyingDrupal,
  isLoadingUST: selectIsLoadingUST,
  isMyLoadingUST: selectIsLoadingMyUST,
  isLoadingDrupal: selectInvestmentDrupalLoading,
  isLoadingUnderlying: selectUnderlyingDrupalLoading,
  quaterlyReport: selectQuaterlyReport,
  isLoadingReport: selectQuaterlyReportLoading,
  processedData: selectProcessedData,
  accountID: selectAccountID
});

/********************** DerivedStates - investmentOptionDetails ******************/

export const investmentInvestmentOptionDetailsDerivedStates = createStructuredSelector({
  tableData: selectTableData,
  isLoadingUnderlyingTable: selectIsLoadingUnderlyingTable,
  accountID: selectAccountID
});



